/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */
export { default as DataIcon } from './components/Twilio/DataIcon';
export { default as PeopleIcon } from './components/Twilio/PeopleIcon';
export { default as ProductIcon } from './components/Twilio/ProductIcon';